
import { defineComponent } from "vue";

export default defineComponent({
  name: "VueOutput",
  props: {
    output: { type: Array, required: true },
    isTyping: { type: Boolean, default: false },
  },
});
